import { isAE, isIQ, isQA } from '@entities/country/model/utils';

export const getCountryPlaceholderOrig = (countryCode: string): string => {
  let placeholder = '05X XXX XXXX';
  
  if (isAE(countryCode)) {
    placeholder = '05X XXX XXXX';
  } else if (countryCode == 'eg' || countryCode == 'EG') {
    placeholder = '0100 XXX XXXX';
  } else if (countryCode == 'bh' || countryCode == 'BH') {
    placeholder = '3600 XXXX';
  } else if (isQA(countryCode)) {
    placeholder = '3312 XXXX';
  } else if (countryCode == 'jo' || countryCode == 'JO') {
    placeholder = '07 9012 XXXX';
  } else if (countryCode == 'tn' || countryCode == 'TN') {
    placeholder = '20 XXX XXX';
  } else if (isIQ(countryCode)) {
    placeholder = '0791 XXX XXXX';
  } else if (countryCode == 'ps' || countryCode == 'PS') {
    placeholder = '0599 XXX XXX';
  } else if (countryCode == 'il' || countryCode == 'IL') {
    placeholder = '0599 XXX XXX';
  } else if (countryCode == 'sa' || countryCode == 'SA') {
    placeholder = '05X XXX XXXX';
  } else if (countryCode == 'kw' || countryCode == 'KW') {
    placeholder = '500 XXXXX';
  } else if (countryCode == 'za' || countryCode == 'ZA') {
    placeholder = '071 XXX XXXX';
  } else if (countryCode == 'es' || countryCode == 'ES') {
    placeholder = '612 34 56 78';
  } else if (countryCode == 'ca' || countryCode == 'CA') {
    placeholder = '(506) XXX-XXXX';
  } else if (countryCode == 'uk' || countryCode == 'UK') {
    placeholder = '07400 XXXXXX';
  } else if (countryCode == 'id' || countryCode == 'ID') {
    placeholder = '0812-XXX-XXX';
  } else if (countryCode == 'my' || countryCode == 'MY') {
    placeholder = '012-XXX XXXX';
  } else if (countryCode == 'sg' || countryCode == 'SG') {
    placeholder = '08XXXXXXX';
  }

  return placeholder;
};

export const getCountryPlaceholder = (countryCode: string, lang: string = ''): string => {
  let placeholder = '05XXXXXXXX';
  
  if (isAE(countryCode)) {
    placeholder = '05XXXXXXXX';
  } else if (countryCode == 'eg' || countryCode == 'EG') {
    placeholder = '01XXXXXXXXX';
  } else if (countryCode == 'bh' || countryCode == 'BH') {
    placeholder = '36XXXXXX';
  } else if (isQA(countryCode)) {
    placeholder = 'XXXXXXXX';
  } else if (countryCode == 'jo' || countryCode == 'JO') {
    placeholder = '07XXXXXXXX';
  } else if (countryCode == 'tn' || countryCode == 'TN') {
    placeholder = '20XXXXXX';
  } else if (isIQ(countryCode)) {
    placeholder = '07XXXXXXXXX';
  } else if (countryCode == 'ps' || countryCode == 'PS') {
    placeholder = '05XXXXXXXX';
  } else if (countryCode == 'il' || countryCode == 'IL') {
    placeholder = '05XXXXXXXX';
  } else if (countryCode == 'sa' || countryCode == 'SA') {
    placeholder = '05XXXXXXXX';
  } else if (countryCode == 'kw' || countryCode == 'KW') {
    placeholder = '5XXXXXXX';
  } else if (countryCode == 'za' || countryCode == 'ZA') {
    placeholder = '071XXXXXXX';
  } else if (countryCode == 'es' || countryCode == 'ES') {
    placeholder = '612XXXXXX';
  } else if (countryCode == 'ca' || countryCode == 'CA') {
    placeholder = '506XXXXXXX';
  } else if (countryCode == 'uk' || countryCode == 'UK') {
    placeholder = '07400XXXXXX';
  } else if (countryCode == 'id' || countryCode == 'ID') {
    placeholder = '08XXXXXXXX';
  } else if (countryCode == 'my' || countryCode == 'MY') {
    placeholder = '01XXXXXXXX';
  } else if (countryCode == 'pk' || countryCode == 'PK') {
    placeholder = '03XXXXXXXXX  ';
  } else if (countryCode == 'sg' || countryCode == 'SG') {
    placeholder = '08XXXXXXX';
  } else if (lang == 'en') {
    placeholder = 'Mobile number';
  } else if (lang == 'ar') {
    placeholder = 'رقم الجوال';
  } else if (countryCode == 'ma' || countryCode == 'MA') {
    placeholder = '6XXXXXXX';
  } else if (countryCode == 'ly' || countryCode == 'LY') {
    placeholder = '09 XXX XXXX';
  } else if (countryCode == 'pt' || countryCode == 'PT') {
    placeholder = '912 XXX XXX';
  }

  return placeholder;
};

export const COUNTRY_PLACEHOLDERS: Record<string, string> = {
  AE: '05XXXXXXXX',
  EG: '01XXXXXXXXX',
  BH: '36XXXXXX',
  QA: 'XXXXXXXX',
  JO: '07XXXXXXXX',
  TN: '20XXXXXX',
  IQ: '07XXXXXXXXX',
  PS: '05XXXXXXXX',
  IL: '05XXXXXXXX',
  SA: '05XXXXXXXX',
  KW: '5XXXXXXX',
  ZA: '071XXXXXXX',
  ES: '612XXXXXX',
  CA: '506XXXXXXX',
  UK: '07400XXXXXX',
  ID: '08XXXXXXXX',
  MY: '01XXXXXXXX',
  PK: '03XXXXXXXXX',
  SG: '08XXXXXXX',
  MA: '6XXXXXXX',
  LY: '09 XXX XXXX',
  PT: '912 XXX XXX',
};

export const getPlaceholderByCountry = (countryCode: string): string => {
  const upperCode = countryCode?.toUpperCase();
  return COUNTRY_PLACEHOLDERS[upperCode] || '05XXXXXXXX';
};
